var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardGooglePay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "80px",
    viewBox: "0 0 120 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "export-badges",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "production-final",
    transform: "translate(-36.000000, -6018.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card_google_pay",
    transform: "translate(36.000000, 6018.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 120,
    height: 80,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(18.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.052,5.27 L39.052,13.436 L44.088,13.436 C45.288,13.436 46.28,13.032 47.064,12.226 C47.87,11.422 48.274,10.462 48.274,9.352 C48.274,8.264 47.87,7.316 47.064,6.508 C46.28,5.682 45.288,5.268 44.088,5.268 L39.052,5.268 L39.052,5.27 Z M39.052,16.31 L39.052,25.782 L36.044,25.782 L36.044,2.396 L44.024,2.396 C46.05,2.396 47.77,3.07 49.188,4.42 C50.628,5.77 51.348,7.414 51.348,9.352 C51.348,11.334 50.628,12.99 49.188,14.316 C47.794,15.646 46.07,16.308 44.022,16.308 L39.052,16.308 L39.052,16.31 Z M54.388,20.884 C54.388,21.668 54.72,22.32 55.386,22.844 C56.05,23.364 56.83,23.626 57.722,23.626 C58.988,23.626 60.114,23.158 61.106,22.224 C62.1,21.286 62.594,20.186 62.594,18.924 C61.656,18.184 60.348,17.814 58.67,17.814 C57.45,17.814 56.43,18.11 55.614,18.698 C54.796,19.286 54.388,20.012 54.388,20.884 Z M58.28,9.254 C60.504,9.254 62.258,9.848 63.546,11.034 C64.83,12.222 65.474,13.85 65.474,15.918 L65.474,25.782 L62.596,25.782 L62.596,23.562 L62.466,23.562 C61.222,25.39 59.566,26.306 57.494,26.306 C55.73,26.306 54.252,25.782 53.064,24.738 C51.876,23.692 51.282,22.386 51.282,20.818 C51.282,19.162 51.908,17.846 53.162,16.866 C54.416,15.886 56.088,15.396 58.182,15.396 C59.966,15.396 61.44,15.722 62.594,16.376 L62.594,15.688 C62.594,14.644 62.18,13.756 61.352,13.028 C60.5542391,12.3101177 59.5151104,11.9194625 58.442,11.934 C56.762,11.934 55.434,12.64 54.452,14.058 L51.804,12.39 C53.264,10.3 55.424,9.254 58.28,9.254 Z M81.986,9.778 L71.946,32.838 L68.84,32.838 L72.568,24.77 L65.964,9.778 L69.234,9.778 L74.008,21.276 L74.072,21.276 L78.716,9.776 L81.986,9.778 Z",
    id: "Shape",
    fill: "#5F6368",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.896,14.268 C26.896,13.322 26.816,12.408 26.664,11.536 L13.976,11.536 L13.976,16.712 L21.244,16.712 C20.9430287,18.3831748 19.9719035,19.8586493 18.556,20.796 L18.556,24.156 L22.894,24.156 C25.434,21.816 26.896,18.356 26.896,14.268",
    id: "Shape",
    fill: "#4285F4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.976,27.4 C17.608,27.4 20.664,26.21 22.894,24.158 L18.556,20.796 C17.35,21.608 15.796,22.082 13.976,22.082 C10.468,22.082 7.488,19.718 6.424,16.534 L1.956,16.534 L1.956,19.996 C4.24184797,24.5371718 8.89197185,27.4022981 13.976,27.402",
    id: "Shape",
    fill: "#34A853",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.424,16.534 C5.86273911,14.8652626 5.86273911,13.0587374 6.424,11.39 L6.424,7.928 L1.956,7.928 C1.0114615,9.79834617 0.520226421,11.8646851 0.522,13.96 C0.522,16.13 1.042,18.18 1.956,19.994 L6.424,16.532 L6.424,16.534 Z",
    id: "Shape",
    fill: "#FABB05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.976,5.842 C15.96,5.842 17.736,6.522 19.136,7.858 L19.136,7.86 L22.976,4.024 C20.648,1.856 17.608,0.524 13.978,0.524 C8.89441559,0.523321579 4.24440402,3.38760491 1.958,7.928 L6.426,11.39 C7.49,8.206 10.47,5.842 13.978,5.842",
    id: "Shape",
    fill: "#E94235",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 82.57 0 82.57 36 0 36"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardGooglePay);
export default __webpack_public_path__ + "static/media/card_google-pay.1d895c3cefa106757350d18c07d1ae3a.svg";
export { ForwardRef as ReactComponent };